import { DayCountConventionEnum, SavingsAccountMetaDataDto } from '../../../../defs/api';

export class SavingsAccountMetaDataMobxDto implements SavingsAccountMetaDataDto {
    dayCountConvention: DayCountConventionEnum | null;

    interestRate: number;

    taxRate?: number;

    static create(dto: SavingsAccountMetaDataDto): SavingsAccountMetaDataMobxDto {
        const mobxDto = new SavingsAccountMetaDataMobxDto();
        return Object.assign(mobxDto, dto, { interestRate: dto.interestRate * 100 });
    }

    static createFromArray(dtos: SavingsAccountMetaDataDto[]): SavingsAccountMetaDataMobxDto[] {
        const createdDtos: SavingsAccountMetaDataMobxDto[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(SavingsAccountMetaDataMobxDto.create(dto));
        });

        return createdDtos;
    }
}
